import { flow, types, getEnv, Instance } from "mobx-state-tree";

import {
  emptyOrganization,
  OrganizationDetailsResponse,
} from "../../api-models/response/organization/OrganizationDetailsResponse";
import { endpoints } from "../api/ApiEndpoints";
import { Organization } from "./Organization";
import OrganizationInput from "./OrganizationInput";
import { StorageModel } from "../storage/StorageModel";

const CurrentOrganizationModel = types.model({
  organization: types.optional(types.frozen<Organization>(), new Organization(emptyOrganization)),
});

export const CurrentOrganizationStorageModel = types
  .compose(CurrentOrganizationModel, StorageModel)
  .named("CurrentOrganizationStorageModel")
  .actions((self) => {
    return {
      mapResponse(response: OrganizationDetailsResponse) {
        self.organization = new Organization(response);
      },
      editOrganization: flow(function* editOrganization(organization: OrganizationInput) {
        const endpoint = endpoints.get("organization");
        yield getEnv(self).api.put(endpoint, organization);
        yield self.load();
      }),
    };
  })
  .views((self) => ({
    get endpoint() {
      const endpoint = endpoints.get("organization");
      return endpoint;
    },
    get isLoading() {
      return self.organization.id === 0;
    },
    get organizationIsNonGerman() {
      return self.organization.countryCode !== "DE";
    },
  }));

export type CurrentOrganizationStorage = Instance<typeof CurrentOrganizationStorageModel>;
